import React from 'react'
import PropTypes from 'prop-types'
import request from 'superagent'
import languages from '../../constants/languages'
import { googleApiKey } from '../../constants/serialized'
import languageHelper from '../../helpers/language_helper'
import './translatable_paragraph.scss'
import i18n from '../../../i18n'

export default class TranslatableParagraph extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      content: props.content,
      translated: false
    }
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps({ content }) {
    if (content != this.props.content) {
      this.setState({ content, translated: false })
    }
  }

  toggleTranslation() {
    if (this.state.translated) {
      // Show original
      this.setState({
        translated: false,
        content: this.props.content
      })
    } else {
      this.translate(this.props.content, languageHelper.pageLocale)
        .then((content) => {
          this.setState({
            translated: true,
            content
          })
        })
    }
  }

  translate(q, target) {
    return new Promise((resolve, reject) => {
      request.post(`https://www.googleapis.com/language/translate/v2/?key=${googleApiKey}`)
        .send({ q, target, format: 'text' })
        .set('Accept', 'application/json')
        .end((err, res) => {
          if (err) {
            reject(err)
          } else {
            resolve(res.body.data.translations[0].translatedText)
          }
        })
    })
  }

  get targetLanguageName() {
    const targetLanguage = languages.find(({ code }) => code === languageHelper.pageLocale)
    return targetLanguage ? targetLanguage.name : null
  }

  get content() {
    return this.state.content || this.props.content
  }

  render() {
    const { content, className, enabled, ...props } = this.props
    return (
      <React.Fragment>
        { enabled &&
          <button styleName="btn-translate" onClick={ () => this.toggleTranslation() }>
            <img src="/assets/image/common/icon_google_g.svg" width="18" height="18" />
            { this.state.translated
              ? <span>{ i18n.t('listings:translation.show_original') }</span>
              : <React.Fragment><span className="notranslate">{ this.targetLanguageName }</span><span>{ i18n.t('listings:translation.translate_to') }</span></React.Fragment>
            }
          </button>
        }
        <p className={`notranslate ${className}`} styleName="content" { ...props }>{ this.content }</p>
      </React.Fragment>
    )
  }

  static propTypes = {
    content: PropTypes.string,
    className: PropTypes.string,
    enabled: PropTypes.bool
  }

  static defaultProps = {
    content: '',
    className: '',
    enabled: true
  }
}
